import { Reveal, SectionHead, Em } from "@/components/Reveal";

const shots = [1, 2, 3, 4, 5, 6, 7, 8, 9];

export const TestimonialsSection = () => (
  <section data-testid="testimonials-section" className="mx-auto max-w-6xl px-5 py-20 sm:py-28">
    <SectionHead eyebrow="REAL WOMEN. REAL SHIFTS. REAL LIFE." center>
      WHEN A WOMAN CHOOSES
      <br />
      HER VISION, SHE <Em>MOVES DIFFERENTLY.</Em>
    </SectionHead>

    <Reveal className="mx-auto mb-10 max-w-xl text-center">
      <p className="font-mono text-[11px] tracking-[0.3em] text-cream/50">WORDS FROM DASHA’S COMMUNITY</p>
      <p className="mt-3 text-sm text-cream/60">
        Real, unedited screenshots from across Dasha’s books, programs, and sessions. Names and handles
        removed for privacy.
      </p>
    </Reveal>

    <Reveal className="mx-auto mb-14 grid max-w-4xl gap-6 sm:grid-cols-2">
      <blockquote
        data-testid="quote-relationship"
        className="relative overflow-hidden border border-white/10 bg-card p-8 text-left"
      >
        <div
          aria-hidden="true"
          className="absolute inset-x-0 top-0 h-1.5 bg-cover bg-center"
          style={{ backgroundImage: "url(/assets/leopard.jpg)" }}
        />
        <p className="font-serif text-xl italic leading-relaxed text-cream sm:text-2xl">
          “After one session with Dasha I got into my dream relationship. 6.5 years later — we’re still
          happy.”
        </p>
        <footer className="mt-5 font-mono text-[10px] tracking-[0.3em] text-lime">— PRIVATE CLIENT</footer>
      </blockquote>
      <blockquote
        data-testid="quote-business"
        className="relative overflow-hidden border border-white/10 bg-card p-8 text-left"
      >
        <div
          aria-hidden="true"
          className="absolute inset-x-0 top-0 h-1.5 bg-cover bg-center"
          style={{ backgroundImage: "url(/assets/leopard.jpg)" }}
        />
        <p className="font-serif text-lg italic leading-relaxed text-cream sm:text-xl">
          “Omg — it was $300K in 8 months in my elderly care business. Then I got a house to host wellness
          retreats — $2.5M, in my name, a year and a half later. Couldn’t have done it without you Dasha.
          Can’t believe you held the vision for me when I was in a trailer.”
        </p>
        <footer className="mt-5 font-mono text-[10px] tracking-[0.3em] text-lime">— PRIVATE CLIENT</footer>
      </blockquote>
    </Reveal>

    <div data-testid="testimonial-grid" className="columns-2 gap-3 sm:columns-3 sm:gap-4">
      {shots.map((n, i) => (
        <Reveal key={n} delay={Math.min(i * 0.05, 0.3)} y={20} className="mb-3 break-inside-avoid sm:mb-4">
          <img
            src={`/assets/testi/testi-${n}.jpg`}
            alt="Real message from a member of Dasha Love's community"
            loading="lazy"
            data-testid={`testimonial-${n}`}
            className="w-full border border-white/10 shadow-[0_20px_40px_rgba(0,0,0,0.5)] transition-transform duration-500 hover:scale-[1.02] hover:rotate-[-0.5deg]"
          />
        </Reveal>
      ))}
    </div>

    <Reveal className="mt-10 text-center">
      <p className="mx-auto max-w-md font-mono text-[10px] leading-relaxed tracking-[0.15em] text-cream/35">
        INDIVIDUAL EXPERIENCES VARY. THESE MESSAGES REFLECT PERSONAL EXPERIENCES AND ARE NOT GUARANTEES OF
        ANY SPECIFIC RESULT.
      </p>
    </Reveal>
  </section>
);
